import React, { PureComponent } from "react";
export class AlertSmallIcon extends PureComponent {
  props: Object;
  render() {
    const { ...rest } = this.props;
    return (
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" {...rest}>
        <title>Alert-16x16</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Alert-16x16-Blue" stroke="none" strokeWidth="1px" fill="none" fillRule="evenodd" strokeLinecap="square">
          <g id="bell-53" transform="translate(2.000000, 1.000000)" stroke="#111111">
            <path
              d="M8,12.0909091 C8,13.1727273 7.13333333,14 6,14 C4.86666667,14 4,13.1727273 4,12.0909091"
              id="Shape"
            />
            <path
              d="M10.6666667,7.63636364 C10.6666667,6.04545455 10.6666667,4.45454545 10.6666667,4.45454545 C10.6666667,1.97272727 8.6,0 6,0 C3.4,0 1.33333333,1.97272727 1.33333333,4.45454545 C1.33333333,4.45454545 1.33333333,6.04545455 1.33333333,7.63636364 C1.33333333,10.1818182 0,12.0909091 0,12.0909091 L12,12.0909091 C12,12.0909091 10.6666667,10.1818182 10.6666667,7.63636364 Z"
              id="Shape"
            />
          </g>
        </g>
      </svg>
    );
  }
}
export default AlertSmallIcon;



// WEBPACK FOOTER //
// ./src/_icons/AlertSmallIcon/index.js